import http from './api'
import { User } from '../types/user'
import { authUserId } from '../utils/userProfile'

function asAuthUser(raw: Record<string, unknown>): User {
  const {
    password: _password,
    resetToken: _resetToken,
    resetTokenExpiresAt: _exp,
    verificationToken: _vt,
    ...rest
  } = raw
  const id = authUserId(rest as { _id?: string; id?: string })
  return { ...rest, _id: id } as User
}

class UsersService {
  async update(id: string, formData: FormData): Promise<User> {
    const { data } = await http.patch(`/users/${id}`, formData)
    return asAuthUser(data)
  }

  async delete(id: string): Promise<unknown> {
    const { data } = await http.delete(`/users/${id}`)
    return data
  }
}

const usersService = new UsersService()
export default usersService
